import type { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'
import { deserialize } from 'ts-jackson'
import { ReportConfigEntity } from './model'

export const ReportConfigService = (client: AxiosInstance) => {
  return {
    async getReportConfigsByReportCode(reportCode: string): Promise<ReportConfigEntity[]> {
      const { data } = await wrapApiCall(() =>
        client.get<
          | { data?: Record<string, unknown>[] | Record<string, unknown> }
          | Record<string, unknown>[]
          | Record<string, unknown>
        >(`/report-configs/${reportCode}`)
      )
      const rawConfigs: Record<string, unknown>[] = Array.isArray(
        (data as { data?: unknown })?.data
      )
        ? (data as { data: Record<string, unknown>[] }).data
        : Array.isArray(data)
          ? data
          : (data as { data?: unknown })?.data
            ? [(data as { data: Record<string, unknown> }).data]
            : data
              ? [data]
              : []
      return rawConfigs.map((item: Record<string, unknown>) =>
        deserialize(item, ReportConfigEntity)
      )
    },
  }
}
